module.exports = __webpack_public_path__ + "media/images/lb/691-f70916bec70f06762609290258b65fef.svg";